<template>
  <div class="main-info">
    <div class="meta-info" v-if="information.infoOptions.date">
      <div class="info-icon" v-html="SVG.CALENDAR" />

      <span>{{ formatDate(information.infoOptions.date) }}</span>
    </div>
    <div class="meta-info">
      <div class="info-icon" v-html="SVG.EYE" />
      <span>{{ information.infoOptions.nb_views }}</span>
    </div>
    <div>
      <h4 class="title">
        {{ information.infoOptions.title }}
      </h4>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { SVG } from "../../../../utils/const";
export default defineComponent({
  name: "main-info",
  props: {
    information: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SVG,
    };
  },
  methods: {
    formatDate(date) {
      var dt = new Date(date);
      var day = (dt.getDate() < 10 ? "0" : "") + dt.getDate();
      var month = (dt.getMonth() < 9 ? "0" : "") + (dt.getMonth() + 1);
      var year = dt.getFullYear();
      let newDate = day + "/" + month + "/" + year;
      return newDate;
    },
  },
});
</script>

<style></style>
